import sound from "../../sound";
import { Result } from "../result/type";
import Matter from "matter-js";

const Plinko: any = {};

const baseIterations = 10;
const CATEGORY_BALL = 0b0001;
const CATEGORY_PEG = 0b0010;
// Initial reassign global variable;
let dropBallCheck: any;
let row: any;
let gotCollideData: any = undefined;
let gotSpaceData: any = undefined;
let gotWallData: any = undefined;

const defaultAirFriction = 0.042;

// Main function to create the Plinko game
Plinko.create = (element: any, r: number) => {
  row = r;

  const Engine = Matter.Engine,
    Render = Matter.Render,
    Runner = Matter.Runner,
    World = Matter.World,
    Bodies = Matter.Bodies;

  // Create the physics engine
  const engine = Engine.create({
    positionIterations: baseIterations,
    velocityIterations: baseIterations,
    constraintIterations: baseIterations,
  }),
    world = engine.world;

  // Create the renderer for visualizing the game
  const render = Render.create({
    element,
    engine: engine,
    options: {
      wireframes: false,
      showSleeping: false,
      width: 630,
      height: 650,
      background: "transparent",
    },
  });

  // Create runners to manage the simulation
  const runner1 = Runner.create();
  const runner2 = Runner.create();
  runner1.isFixed = true;


  // Engine update still processing even when Document hidde/minimize
  const tick: any = {};
  const tickGSAPWhileHidde = (value: boolean): any => {
    if (value === false) {
      document.removeEventListener("visibilitychange", tick.fn);
      window.removeEventListener("blur", tick.fnBlur);
      window.removeEventListener("focus", tick.fnFocus);

      clearTimeout(tick.id);
      clearTimeout(tick.blur);
      return;
    }
    const onChange = () => {
      clearTimeout(tick.id);
      clearTimeout(tick.blur);

      if (document.hidden || document.visibilityState == "hidden") {

        const update = () => {
          Engine.update(engine, 1000 / 60);
          tick.id = setTimeout(update, 1000 / 60);
        };
        tick.id = setTimeout(update, 1000 / 60);
      } else {
      }
    };
    const onBlur = () => {
      clearTimeout(tick.blur);
      clearTimeout(tick.id);
    };
    const onFocus = () => {
      document.querySelectorAll("iframe").forEach((i) => {
        i.parentNode?.removeChild(i);
        i.remove();
      });
      clearTimeout(tick.blur);
    };
    document.addEventListener("visibilitychange", onChange);
    window.addEventListener("blur", onBlur);
    window.addEventListener("focus", onFocus);
    tick.fn = onChange;
    tick.fnBlur = onBlur;
    tick.fnFocus = onFocus;

    onChange();
  };

  tickGSAPWhileHidde(true);
  const orientation = document.querySelector(".game-area.landscape")
    ? "landscape"
    : "portrait";
  Render.run(render);

  Runner.run(runner1, engine);
  Runner.run(runner2, engine);

  // Initial reassign local variable;
  let dropBall: any;
  let spaceSetting: any, global_collideSetting: any;
  let pegs: Matter.Body[];
  let pegsShadow: Matter.Body[];
  let wall: Matter.Body[];

  // Finish sensor
  const finish = Bodies.rectangle(250, 630, 1000, 50, {
    isStatic: true,
    label: `finish`,
    collisionFilter: {
      category: CATEGORY_PEG,
    },
    render: {
      fillStyle: "#ffffff",
      visible: false,
    },
  });

  World.add(world, finish);

  const data = {

    // Function to change the number of rows in the game
    changeRow: (r: number) => {
      row = r;
      pegs &&
        pegs.length &&
        pegs.map((peg) => Matter.World.remove(engine.world, peg));
      pegsShadow &&
        pegsShadow.length &&
        pegsShadow.map((peg) => Matter.World.remove(engine.world, peg));
      wall &&
        wall.length &&
        wall.map((peg) => Matter.World.remove(engine.world, peg));

      pegs = [];
      pegsShadow = [];
      wall = [];

      (async () => {
        spaceSetting =
          gotSpaceData || (await (await fetch("/space.json")).json());
        gotSpaceData = spaceSetting;
        const collideSetting =
          gotCollideData || (await (await fetch("/collide.json")).json());
        gotCollideData = collideSetting;
        global_collideSetting = collideSetting;
        const dataSpace: any = spaceSetting;

        let spacingY = dataSpace[row][orientation].y;
        let spacingX = dataSpace[row][orientation].x;
        let size = dataSpace[row][orientation].size;

        dropBall = (idx: number, firstPath: "L" | "R") => {
          const middle = 300 - size / 2;
          const left = middle - spacingX + size / 2;
          const right = middle + spacingX - size / 2;
          const dataFirstPath = {
            L: [
              { x: left, changeTo: "R" },
              { x: middle, changeTo: "L" },
              { x: middle - spacingX / 2, changeTo: "" },
            ],
            R: [
              { x: right, changeTo: "L" },
              { x: middle, changeTo: "R" },
              { x: middle + spacingX / 2, changeTo: "" },
            ],
          };
          const randomeSelectDataDirstPath =
            dataFirstPath[firstPath][
            Number(
              randomNumber(0, dataFirstPath[firstPath].length - 1).toFixed()
            )
            ];
          const circle = Bodies.circle(
            randomeSelectDataDirstPath.x,
            70,
            spacingX / 3.5,
            {
              restitution: 0,
              density: 0.001,
              frictionAir: 0.15,
              angularSpeed: 10,
              friction: 1,
              frictionStatic: 10,

              sleepThreshold: 0,
              label: `ball-${idx}-${randomeSelectDataDirstPath.changeTo}`,
              render: {
                fillStyle: "#ff00ff",
                visible: true,
              },
            }
          );
          circle.collisionFilter.category = CATEGORY_BALL;
          circle.collisionFilter.mask = CATEGORY_PEG;
          World.add(world, circle);
          Matter.Body.setAngle(circle, -0.3);

          return circle;
        };

        let i: any, j: any, lastI: any;
        for (i = 0; i < (row % 2 === 0 ? row + 4 : row + 3); i++) {
          for (j = 1; j <= i && i <= row + 2; j++) {
            pegs.push(
              Bodies.circle(
                280 + (j * spacingX - i * (spacingX / 2)),
                20 + i * spacingY,
                size * collideSetting.pegScale,
                {
                  isStatic: true,
                  render: {
                    fillStyle: "#fff",
                    visible: true,
                  },
                  label: `pegs-${i}-${j}`,
                }
              )
            );
            if (collideSetting.pegColor) {

              pegsShadow.push(
                Bodies.circle(
                  280 + (j * spacingX - i * (spacingX / 2)),
                  20 + i * spacingY,
                  size * collideSetting.pegScale * 1.75,
                  {
                    isStatic: true,
                    render: {
                      fillStyle: collideSetting.pegColor,
                      visible: false,
                    },
                    label: `shadow_pegs-${i}-${j}`,
                  }
                )
              );
            }
          }
          lastI = i;
        }

        const wallSetting =
          gotWallData || (await (await fetch("/wall.json")).json());
        gotWallData = wallSetting;
        const { startX, spacingXScale } = wallSetting[orientation][row];

        for (i = 0; i < row + 2; i++) {
          wall.push(
            Bodies.rectangle(
              startX +
              -1 * spacingX +
              ((row + 6) * spacingX - i * spacingX * spacingXScale),
              lastI * spacingY + 190,
              size * 2.5,
              lastI + 350,
              {
                isStatic: true,
                label: `wall`,
                collisionFilter: {
                  category: CATEGORY_PEG,
                },
                render: {
                  fillStyle: "rgb(147,154,176)",
                  visible: wallSetting.visible,
                },
                chamfer: {
                  radius: [size, size, 0, 0],
                },
              }
            )
          );
        }
        pegs = pegs.slice(3);
        pegs.map((i: Matter.Body, idx) => {
          i.collisionFilter.category = CATEGORY_PEG;
          World.add(world, i);
          Matter.Body.setAngle(i, -0.3);
        });
        if (collideSetting.pegColor) {

          pegsShadow = pegsShadow.slice(3);
          pegsShadow.map((i: Matter.Body, idx) => {
            World.add(world, i);
            Matter.Body.setAngle(i, -0.3);
          });
        }
        wall.map((i: Matter.Body, idx) => {
          i.collisionFilter.category = CATEGORY_PEG;
          World.add(world, i);
        });
      })();
    },
    // Function to get the current row count
    row: () => row,
    touchPegObj: {} as any,
    // Function to stop the game simulation
    stop: () => {
      Matter.Render.stop(render);
      Matter.Runner.stop(runner1);
      Matter.Runner.stop(runner2);
      data.touchPegObj = {};
    },
    // Function to animate the balls dropping in the Plinko game
    animate: async (
      items: any,
      onSleep: (data: Result, idx: number) => void
    ) => {
      const collideSetting =
        global_collideSetting || (await (await fetch("/collide.json")).json());
      const delay = collideSetting.delayManual;
      items.map((item: any, idx: number) => {
        data.touchPegObj[idx + ""] = 0;
        let interval: any = undefined;
        interval = setInterval(() => {
          if (dropBall && interval) {
            setTimeout(() => {
              const off = data.singleAnimate(
                item,
                (...a: [Result, number]) => {
                  onSleep(...a);
                  typeof off === "function" && off();
                },
                idx
              );
            }, delay * idx);
            clearInterval(interval);
            interval = undefined;
          }
        });
      });
    },
    // Function to handle the animation of a single ball
    singleAnimate: (
      item: any,
      onSleep: (data: Result, idx: number) => void,
      i: number
    ) => {

      const idx = Date.now();
      let finishFired = false;
      // Event handler for collision events
      // src/ui/game/PlinkoSAT.ts

      const collEvent = async (e: any, off: () => void) => {
        // Fetch collision settings from a JSON file or use global settings if available
        const collideSetting =
          global_collideSetting || (await (await fetch("/collide.json")).json());

        // Check if the first body in the collision pair is a ball and not the current ball being tracked // unused for now
        if (
          e.pairs[0].bodyB.label.indexOf(`ball`) == 0 &&
          e.pairs[0].bodyB.label.indexOf(idx) !== 5
        )
          return;

        // Check if the first body in the collision pair is a ball and not the current ball being tracked // unused for now
        if (
          e.pairs[0].bodyA.label.indexOf(`ball`) == 0 &&
          e.pairs[0].bodyA.label.indexOf(idx) !== 5
        )
          return;

        // ===== Start Check if the ball and peg are on the same row or the top row

        // Determine which body is the ball and which is the peg based on their labels
        const ballTemp: Matter.Body =
          e.pairs[0].bodyB.label.indexOf(`ball`) == 0
            ? e.pairs[0].bodyB
            : e.pairs[0].bodyA.label.indexOf(`ball`) == 0
              ? e.pairs[0].bodyA
              : null;
        const pegsTemp: Matter.Body =
          e.pairs[0].bodyB.label.indexOf(`pegs`) == 0
            ? e.pairs[0].bodyB
            : e.pairs[0].bodyA.label.indexOf(`pegs`) == 0
              ? e.pairs[0].bodyA
              : null;

        // (continue if ball go to bottom level of peg not touching with same peg level or top peg level)
        if (ballTemp && pegsTemp) {
          const samePageRow =
            ballTemp.label.indexOf(
              pegsTemp.label.split("-").slice(0, 2).join("-")
            ) > -1;
          const topPeg = pegsTemp.label.split("-").slice(0, 1);
          topPeg[1] = Number(topPeg[1]) - 1 + "";
          const topPageRow = ballTemp.label.indexOf(topPeg.join("-")) > -1;
          if (samePageRow) return;
          if (topPageRow) return;
        }
        // ===== End Check if the ball and peg are on the same row or the top row



        // ==== Start Processing if the ball has reached the finish line
        if (
          e.pairs[0].bodyB.label.indexOf(`finish`) == 0 &&
          e.pairs[0].bodyA.label.indexOf(`ball`) == 0
        ) {
          if (!finishFired) {
            finishFired = true;
          } else {
            return;
          }
          World.remove(world, e.pairs[0].bodyA);
          delete data.touchPegObj[idx];
          sound.playHole();
          onSleep(item, i);
          off();
          Matter.Engine.update(engine, 1000 / 60);
          return;
        }

        if (
          e.pairs[0].bodyB.label.indexOf(`ball`) == 0 &&
          e.pairs[0].bodyA.label.indexOf(`finish`) == 0
        ) {
          if (!finishFired) {
            finishFired = true;
          } else {
            return;
          }
          World.remove(world, e.pairs[0].bodyB);
          delete data.touchPegObj[idx];
          sound.playHole();
          onSleep(item, i);
          off();
          Matter.Engine.update(engine, 1000 / 60);
          return;
        }
        // ==== End Processing if the ball has reached the finish line

        // ==== Start Jump Animation

        // declare body for reassign to valid role;
        let ballBody: any, pegBody: any;

        // Determine which body is the ball and which is the peg based on their labels
        if (
          e.pairs[0].bodyB.label.indexOf(`ball`) == 0 &&
          e.pairs[0].bodyA.label.indexOf(`pegs`) == 0
        ) {
          ballBody = e.pairs[0].bodyB;
          pegBody = e.pairs[0].bodyA;
        }

        if (
          e.pairs[0].bodyB.label.indexOf(`pegs`) == 0 &&
          e.pairs[0].bodyA.label.indexOf(`ball`) == 0
        ) {
          ballBody = e.pairs[0].bodyA;
          pegBody = e.pairs[0].bodyB;
        }

        // If no ball or peg is found, return
        if (!ballBody || !pegBody) return;

        // Get the prize and path associated with the current item
        const { prize, path } = item;

        // Create an array of directions from the path
        const arrDirection: string[] = path.map((a: string) => a);
        arrDirection.shift();

        // If the ball has a label, add it to the direction array
        if (ballBody.label.split("-")[2]) {
          arrDirection.unshift(ballBody.label.split("-")[2]);
        }

        // Get the number of times the ball has touched a peg
        const touchPeg = data.touchPegObj[idx];

        // Define the jump behavior for the ball when it hits a peg
        const jump: any = {
          R: (ballBody: Matter.Body, pegBody: Matter.Body, idx: number) => {
            Matter.Body.setStatic(ballBody, false);
            // increment peg number
            data.touchPegObj[idx] = data.touchPegObj[idx] + 1;
            // apply peg number to ball label
            ballBody.label = [
              ballBody.label.split("-")[0],
              ballBody.label.split("-")[1],
              ballBody.label.split("-")[2],
              "",
            ]
              .join("-")
              .concat(pegBody.label);

            // animate peg if enable
            if (collideSetting.pegColor) {
              setTimeout(() => {
                const clonedPegBody = pegsShadow.find(({ label }) => label.includes(pegBody.label))!;
                clonedPegBody.render.visible = true;
                clonedPegBody.render.fillStyle = collideSetting.pegColor;
                const animateVibration = () => {
                  setTimeout(() => {
                    clonedPegBody.render.opacity = 0.15;

                    setTimeout(() => {
                      clonedPegBody.render.visible = false;

                    }, collideSetting.vibrationDuration);
                  }, collideSetting.vibrationDelay);
                };

                animateVibration();

              }, 0);
            }
            // Reset to initial value for good control when applying force vector
            Matter.Body.setAngle(ballBody, -0.3);
            Matter.Body.setVelocity(ballBody, { x: 0, y: 0 });
            ballBody.frictionAir = defaultAirFriction;
            Matter.Body.setAngularVelocity(ballBody, 0);
            const randomDensity = randomNumber(0.00095, 0.00155);
            ballBody.density = randomDensity;
            // Applying force vector direction to get jump motion
            const densityScale = (randomDensity / 0.0015);
            Matter.Body.applyForce(
              ballBody,
              {
                y: ballBody.position.y,
                x: ballBody.position.x,
              },
              {
                x:
                  collideSetting[orientation]["R"][row].applyForce.x *
                  densityScale,
                y:
                  collideSetting[orientation]["R"][row].applyForce.y *
                  densityScale,
              }
            );
            // Generate random air friction with custom range to get variation in motion
            ballBody.frictionAir = randomNumber(0.055, 0.065);
            // Playing ball touch with peg
            sound.playBall(Number(randomNumber(0, 2).toFixed()));
          },
          L: (ballBody: Matter.Body, pegBody: Matter.Body, idx: number) => {
            Matter.Body.setStatic(ballBody, false);
            // increment peg number
            data.touchPegObj[idx] = data.touchPegObj[idx] + 1;
            // apply peg number to ball label
            ballBody.label = [
              ballBody.label.split("-")[0],
              ballBody.label.split("-")[1],
              ballBody.label.split("-")[2],
              "",
            ]
              .join("-")
              .concat(pegBody.label);

            // animate peg if enable
            if (collideSetting.pegColor) {
              setTimeout(() => {
                const clonedPegBody = pegsShadow.find(({ label }) => label.includes(pegBody.label))!;
                clonedPegBody.render.visible = true;
                clonedPegBody.render.fillStyle = collideSetting.pegColor;
                const animateVibration = () => {
                  setTimeout(() => {
                    clonedPegBody.render.opacity = 0.15;

                    setTimeout(() => {
                      clonedPegBody.render.visible = false;

                    }, collideSetting.vibrationDuration);
                  }, collideSetting.vibrationDelay);
                };

                animateVibration();

              }, 0);
            }
            // Reset to initial value for good control when applying force vector
            Matter.Body.setAngle(ballBody, -0.3);
            Matter.Body.setVelocity(ballBody, { x: 0, y: 0 });
            Matter.Body.setAngularVelocity(ballBody, 0);
            ballBody.frictionAir = defaultAirFriction;
            const randomDensity = randomNumber(0.00095, 0.00155);
            ballBody.density = randomDensity;
            // Applying force vector direction to get jump motion
            const densityScale = (randomDensity / 0.0015);
            Matter.Body.applyForce(
              ballBody,
              {
                y: ballBody.position.y,
                x: ballBody.position.x,
              },
              {
                x:
                  collideSetting[orientation]["L"][row].applyForce.x *
                  densityScale,
                y:
                  collideSetting[orientation]["L"][row].applyForce.y *
                  densityScale,
              }
            );
            // Generate random air friction with custom range to get variation in motion
            ballBody.frictionAir = randomNumber(0.055, 0.065);
            // Playing ball touch with peg
            sound.playBall(Number(randomNumber(0, 2).toFixed()));
          },
        };

        // If the ball has a direction to jump, perform the jump
        if (arrDirection[touchPeg]) {
          Matter.Body.setStatic(ballBody, true);
          jump[arrDirection[touchPeg]](ballBody, pegBody, idx);
          Matter.Engine.update(engine, 1000 / 60);
        }
        // ==== End Jump Animation
      };

      // ==== Start droping new ball 
      // Check if drob ball function is available
      if (!dropBall) {
        dropBallCheck = setInterval(() => {
          if (dropBall) {
            clearInterval(dropBallCheck);
            // Performing start sound playing even when browser minimize on mobile iphone
            if (
              (document.visibilityState == "hidden" || document.hidden) &&
              document.querySelector(".iPhone")
            ) {
              setTimeout(() => {
                sound.playHole();
                onSleep(item, i);
              }, 500 * row);
              return;
            }
            // initial to start droping new ball
            data.touchPegObj[idx] = 0;
            const ball = dropBall(idx, item.path[0]);
            const collQuery = () => {
              const collisions = Matter.Query.collides(ball, [...pegs, finish]);
              if (collisions.length > 0) {
                const e = { pairs: collisions };
                collEvent(e, () => {
                  // Removing collEvent on end
                  Matter.Events.off(engine, "beforeUpdate", collQuery);
                });
              }
            };
            // listening coll using query with registered body
            Matter.Events.on(engine, "beforeUpdate", collQuery);
          }
        }, 500);
      } else {

        // initial to start droping new ball
        data.touchPegObj[idx] = 0;
        const ball = dropBall(idx, item.path[0]);
        const collQuery = () => {
          const collisions = Matter.Query.collides(ball, [...pegs, finish]);

          if (collisions.length > 0) {
            const e = { pairs: collisions };
            collEvent(e, () => {
              // Removing collEvent on end
              Matter.Events.off(engine, "beforeUpdate", collQuery);
            });
          }
        };
        // listening coll using query with registered body
        Matter.Events.on(engine, "beforeUpdate", collQuery);
      }
      return () => {

      };
      // ==== End droping new ball 
    },
  };

  return data;
};

// Function to generate a random number between min and max
const randomNumber = (min: number, max: number) => {
  return Math.random() * (max - min) + min;
};

export default Plinko;
